import type { NotificationDatabaseEntity } from "./notification-database.type";
import type { ApiEmptyResponse, ApiError } from "@/services/api";

import { useMutation } from "@tanstack/react-query";

import { client } from "@/config/client";

const markAsRead = (id: NotificationDatabaseEntity["id"]) => {
  return client.user.notifications.markAsRead(id);
};

export const useMarkNotificationDatabaseAsRead = () => {
  const { mutate, ...result } = useMutation<
    ApiEmptyResponse,
    ApiError,
    NotificationDatabaseEntity["id"]
  >({
    mutationFn: markAsRead,
  });

  return {
    markAsRead: mutate,
    ...result,
  };
};
